(() => {
  const existing = window.MenoPlayFinalBuy;
  if (existing) {
    existing.init(document);
    return;
  }

  const controllers = new Map();
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isOverlayOpen = () => Boolean(document.querySelector(
    'dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]):not([aria-hidden="true"]), [data-safety-dialog]:not([hidden]):not([aria-hidden="true"]), #eusari-accessibility-dialog:not([hidden]), [data-cart-drawer][open], [data-drawer="drawer-cart"].is-visible, .cart-drawer.is-open, .cart-drawer[aria-hidden="false"]'
  ));

  const focusBuyBox = (buyBox) => {
    const focusTarget = buyBox.querySelector('[data-menoplay-pdp-variant-select], select, input:not([type="hidden"]):not([disabled])') || buyBox;
    focusTarget.focus({ preventScroll: true });
  };

  const scrollToBuyBox = (event, buyBox) => {
    event.preventDefault();
    buyBox.scrollIntoView({ behavior: reducedMotionQuery.matches ? 'auto' : 'smooth', block: 'start' });
    window.setTimeout(() => focusBuyBox(buyBox), reducedMotionQuery.matches ? 0 : 300);
  };

  const nativeOptionForSupply = (variantSelect, supplyDays) => {
    const options = [...variantSelect.options];
    const exact = options.find((option) => option.dataset.menoplayPdpSupplyDays === supplyDays && option.dataset.available === 'true');
    if (exact) return exact;

    const titlePattern = {
      30: /\b(1|un|uno)\s*(frasco|botella)|30\s*d[ií]a/i,
      60: /\b(2|dos)\s*(frascos|botellas)|60\s*d[ií]a/i,
      90: /\b(3|tres)\s*(frascos|botellas)|90\s*d[ií]a/i,
    }[supplyDays];
    return options.find((option) => option.dataset.available === 'true' && titlePattern?.test(option.textContent));
  };

  const selectNativePackage = (variantSelect, supplyDays) => {
    const option = nativeOptionForSupply(variantSelect, Number(supplyDays));
    if (!option) return false;
    if (variantSelect.value !== option.value) {
      variantSelect.value = option.value;
      variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  };

  const destroy = (id) => {
    controllers.get(id)?.abort();
    controllers.delete(id);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-menoplay-pdp-module="final-buy"]').forEach((root) => {
      const id = root.dataset.sectionId;
      const sticky = root.querySelector('[data-final-buy-sticky]');
      const buyBox = document.querySelector('#buybox');
      const hero = document.querySelector('[data-menoplay-pdp-module="hero"]');
      const variantSelect = buyBox?.querySelector('[data-menoplay-pdp-variant-select]');
      const nativeAddToCart = buyBox?.querySelector('button[data-add-to-cart]');

      if (!id || !buyBox || !hero || !variantSelect || !nativeAddToCart) return;

      destroy(id);
      const controller = new AbortController();
      const { signal } = controller;
      controllers.set(id, controller);

      let hasPassedHero = false;
      let buyBoxVisible = false;
      const updateSticky = () => {
        if (!sticky) return;
        const shouldHide = !mobileQuery.matches || !hasPassedHero || buyBoxVisible || isOverlayOpen();
        if (sticky.hidden !== shouldHide) sticky.hidden = shouldHide;
      };

      root.querySelectorAll('[data-final-buy-cta]').forEach((cta) => {
        cta.addEventListener('click', (event) => {
          const supplyDays = cta.dataset.finalBuySupplyDays;
          if (!supplyDays) {
            scrollToBuyBox(event, buyBox);
            return;
          }
          if (!selectNativePackage(variantSelect, supplyDays)) return;
          event.preventDefault();
          nativeAddToCart.click();
        }, { signal });
      });

      const heroObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        hasPassedHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateSticky();
      }, { threshold: 0 });
      const buyBoxObserver = new IntersectionObserver((entries) => {
        buyBoxVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0.15 });
      const overlayObserver = new MutationObserver(updateSticky);

      if (sticky) {
        heroObserver.observe(hero);
        buyBoxObserver.observe(buyBox);
        overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden'], subtree: true });
      }
      mobileQuery.addEventListener('change', updateSticky, { signal });
      document.addEventListener('shopify:section:load', updateSticky, { signal });
      signal.addEventListener('abort', () => {
        heroObserver.disconnect();
        buyBoxObserver.disconnect();
        overlayObserver.disconnect();
      }, { once: true });
      updateSticky();
    });
  };

  const onSectionLoad = (event) => init(event.target);
  const onSectionUnload = (event) => {
    const root = event.target.querySelector('[data-menoplay-pdp-module="final-buy"]');
    if (root?.dataset.sectionId) destroy(root.dataset.sectionId);
  };
  const teardown = () => {
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    controllers.forEach((controller) => controller.abort());
    controllers.clear();
    delete window.MenoPlayFinalBuy;
  };

  window.MenoPlayFinalBuy = { init, teardown };
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  init();
})();
